// InventoryHold reason enum — closed value space defined in the model layer
// (see: app/models/inventory_hold.rb).
//
// 表列寫法（I18N.md §4.1 / FRONTEND.md §7.1）— 禁止用 t(`enums.inventory_hold.reason.${x}`)
// 動態 key；所有 caller 一律走 useInventoryHoldReasonLabel()。
import { useTranslation } from 'react-i18next';

export const INVENTORY_HOLD_REASONS = [
  'quality_issue',
  'customer_reserve',
  'regulatory',
  'damage',
  'recall',
  'other',
] as const;

export type InventoryHoldReason = typeof INVENTORY_HOLD_REASONS[number];

export function useInventoryHoldReasonLabel() {
  const { t } = useTranslation();
  return (reason: string | null | undefined): string => {
    if (!reason) return '';
    switch (reason as InventoryHoldReason) {
      case 'quality_issue':    return t('enums.inventory_hold.reason.quality_issue');
      case 'customer_reserve': return t('enums.inventory_hold.reason.customer_reserve');
      case 'regulatory':       return t('enums.inventory_hold.reason.regulatory');
      case 'damage':           return t('enums.inventory_hold.reason.damage');
      case 'recall':           return t('enums.inventory_hold.reason.recall');
      case 'other':            return t('enums.inventory_hold.reason.other');
      default:                 return reason;
    }
  };
}
